var clientKey = 'client';
export var correlationIdKey = 'correlationId';
export var setManageCardHoldersCorrelationId = function (id) {
    sessionStorage.setItem(correlationIdKey, id);
};
export var getCorrelationId = function () {
    return sessionStorage.getItem(correlationIdKey);
};
export var getManageCardHoldersClient = function () {
    return localStorage.getItem(clientKey);
};
